export default {
  main: () => import("/vercel/path0/layouts/main.vue").then(m => m.default || m)
}